import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const getValueChainKey = "getValueChain" as const;

interface ValueChainData {
    upstream: Array<{
        id: number;
        title: string;
        type: string;
        isIntermediate?: boolean;
        quantity?: number | null;
        ownedByName?: string | null;
        children?: any[];
        depth?: number;
    }>;
    downstream: Array<{
        id: number;
        title: string;
        ownedByName?: string | null;
        isIntermediate?: boolean;
        children?: any[];
        depth?: number;
    }>;
    metadata?: {
        maxUpstreamDepth?: number;
        maxDownstreamDepth?: number;
        totalEntities?: number;
        upstreamCount?: number;
        downstreamCount?: number;
    };
}

export const useValueChain = (productId?: number) => {
    const isEnabled = productId !== undefined;

    const query = useQuery({
        queryKey: [getValueChainKey, productId],
        enabled: isEnabled,
        queryFn: async (): Promise<ValueChainData> => {
            const url = `/api/products/${productId}/value-chain`;
            const response = await loggedInApiCall.get<ValueChainData>(url);
            return response.data;
        },
        staleTime: 30000, // 30 seconds
        cacheTime: 300000, // 5 minutes
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: query.refetch,
    };
};
